import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
providedIn: 'root'
})
export class AccountService 
{ 
	constructor(private http: HttpClient) 
	{ 
		
	}

    login(model:any): Observable<any>
	{
        return this.http.post<any>(environment.apiUrl+'/api/Account/Login', model);
	}

	register(model:any): Observable<any>
	{
        return this.http.post<any>(environment.apiUrl+'/api/Account/Register', model);
	}

	/// Signs in with Google. Returns the same shape as login(): a JWT string on success,
	/// or a numeric code - 1 the token did not verify, 2 deactivated, 6 the address is
	/// not verified by the provider.
	///
	/// Only IdToken carries identity; the rest are locale hints used when the account is
	/// being created for the first time.
	googleSignIn(idToken:string, country:number, countryCode:string, language:number): Observable<any>
	{
        return this.http.post<any>(environment.apiUrl+'/api/Account/GoogleSignIn', {
			IdToken: idToken,
			Country: country,
			CountryCode: countryCode,
			Language: language
		});
	}

	registerByShop(model:any): Observable<any>
	{
        return this.http.post<any>(environment.apiUrl+'/api/Account/RegisterByShop', model);
	}

	resetPasswordRequest(model:any): Observable<any>
	{
        return this.http.post<any>(environment.apiUrl+'/api/Account/ResetPasswordRequest', model);
	}

	resetPasswordByUser(model:any): Observable<any>
	{
        return this.http.post<any>(environment.apiUrl+'/api/Account/ResetPasswordByUser', model);
	}

	confirmEmail(refCode:string, token:string): Observable<any>
	{
        return this.http.post<any>(environment.apiUrl+'/api/Account/ConfirmEmail?'+'refCode='+refCode+'&token='+token, {});
	}

	sendConfirmEmailLink(): Observable<any>
	{
        return this.http.get<any>(environment.apiUrl+'/api/Account/SendConfirmEmail');
	}

	forgotPassword(email:string): Observable<any>
	{
        return this.http.post<any>(environment.apiUrl+'/api/Account/ForgotPassword?'+'email='+ email, {});
	}

	resetPassword(model:any): Observable<any>
	{
        return this.http.post<any>(environment.apiUrl+'/api/Account/ResetPassword', model);
	}

	resetPasswordLinkCheck(token:string): Observable<any>
	{
        return this.http.get<any>(environment.apiUrl+'/api/Account/ResetPasswordLink?'+'token='+ token);
	}

	// register(model:any): Observable<any>
	// {
    //      return this.http.post<any>(environment.apiUrl+'/api/Account/Register', model);
	// }

}
